export enum CustomHttpHeaders {
  recordsCount = "x-bsi-recordscount",
}
